/**
 * @generated SignedSource<<e022239e25c77eebb4bd796c9dc22744>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiCustomAppsDeleteMutation$variables = {
  aiCustomAppID: number;
};
export type aiCustomAppsDeleteMutation$data = {
  readonly deleteAICustomApp: boolean;
};
export type aiCustomAppsDeleteMutation = {
  response: aiCustomAppsDeleteMutation$data;
  variables: aiCustomAppsDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aiCustomAppID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "aiCustomAppID",
        "variableName": "aiCustomAppID"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteAICustomApp",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aiCustomAppsDeleteMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "aiCustomAppsDeleteMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "88143578e3705d702c287771ab56afe7",
    "id": null,
    "metadata": {},
    "name": "aiCustomAppsDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation aiCustomAppsDeleteMutation(\n  $aiCustomAppID: Long!\n) {\n  deleteAICustomApp(aiCustomAppID: $aiCustomAppID)\n}\n"
  }
};
})();

(node as any).hash = "2caa96a6367b50549de488deb61a8c21";

export default node;
